// MainPage.js
import React, { useState } from 'react';
import './sobre_nosotros.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const SobreNosotros = () => {
    const { t, i18n } = useTranslation('sobre_nosotros');

    return (
        <main className="main-content">

            <section className="main__person">

                <div className="main__person__div">
                    <div className="main__person__div__tittle"><span>Ralf Görtz</span></div>
                    <div className="main__person__div__image">
                        <img src={`${process.env.PUBLIC_URL}/images/Imagen-4-scaled.jpg`} alt="logo"></img>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="#fff"><path d="M1000 100C500 100 500 64 0 64V0h1000v100Z" opacity=".5"></path><path d="M1000 100C500 100 500 34 0 34V0h1000v100Z" opacity=".5"></path><path d="M1000 100C500 100 500 4 0 4V0h1000v100Z"></path></svg>
                    </div>
                    <div className="main__person__div__text"></div>
                    <span>{t('ralf_text')}</span>
                </div>


                <div className="main__person__div">
                    <div className="main__person__div__tittle"><span>Alberto Fernández Villarejo</span></div>
                    <div className="main__person__div__image">
                        <img src={`${process.env.PUBLIC_URL}/images/Imagen-5-scaled.jpg`} alt="logo"></img>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="#fff"><path d="M1000 100C500 100 500 64 0 64V0h1000v100Z" opacity=".5"></path><path d="M1000 100C500 100 500 34 0 34V0h1000v100Z" opacity=".5"></path><path d="M1000 100C500 100 500 4 0 4V0h1000v100Z"></path></svg>
                    </div>
                    <div className="main__person__div__text">
                        <span>{t('alberto_text')}</span>
                    </div>
                </div>
            </section>


            <section >
                <div className="main__asociaciones">
                    <div className="main__asociaciones__tittle">{t('miembros_tittle')}</div>
                    <div className="main__asociaciones__text">
                        <ul>
                            <li><strong><a href="https://quiropractica-aeq.com/">{t('miembros_1_tittle')}</a></strong>{t('miembros_1')}</li>
                            <li><strong><a href="https://www.eurospine.org/">{t('miembros_2_tittle')}</a></strong>{t('miembros_2')}</li>
                            <li><strong><a href="https://www.chiropractic-ecu.org/">{t('miembros_3_tittle')}</a></strong>{t('miembros_3_4_linker')}<a href="https://www.wfc.org/es/"><strong>{t('miembros_4_tittle')}</strong></a>{t('miembros_3')}</li>
                        </ul>
                    </div>
                </div>

                <div className="main__asociaciones__logos">
                    <a href="https://quiropractica-aeq.com" target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/LOGOTIPOAEQ.jpg`} alt="logo"></img>
                    </a>

                    <a href="https://www.eurospine.org/" target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/eurospine_logo.png`} alt="logo"></img>
                    </a>

                    <a href="https://www.chiropractic-ecu.org/" target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/logo_ecu.png`} alt="logo"></img>
                    </a>

                    <a href="https://www.wfc.org/es/" target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/wfc-es.png`} alt="logo"></img>
                    </a>
                </div>

            

            </section>
        </main>
    );
};

export default SobreNosotros;
